<template>
  <section
    class="article__breadcrumb py-0 sm:py-2 categories text-md flex flex-nowrap overflow-x-auto sm:overflow-x-hidden"
    :class="{ 'text-primary-300': isOnedioVideo, 'text-primary-200': !isOnedioVideo }"
  >
    <OLink href="/">{{ $t('main.breadcrumbRoot') }}</OLink>
    <div v-for="category in article.breadcrumb" :key="category.route" class="flex flex-nowrap whitespace-nowrap items-center">
      <Arrow class="w-4 h-4" />
      <OLink :href="category.route">{{ category.name }}</OLink>
      <span v-if="category.siblings">
        <span v-for="sub in category.siblings" :key="sub.route">
          <span>,</span>
          <OLink :href="sub.route">
            {{ sub.name }}
          </OLink>
        </span>
      </span>
    </div>
    <div v-if="article.title" class="flex flex-nowrap items-center">
      <Arrow class="w-4 h-4" />
      <span class="whitespace-nowrap sm:whitespace-normal sm:line-clamp-1 font-semibold">{{ article.title }}</span>
    </div>
  </section>
</template>
<script>
import { computed, defineComponent, inject } from '@nuxtjs/composition-api';
import { isVideoArticle } from '../utils/articleUtils';
import Arrow from '~/static/images/arrow.svg?inline';
import { OLink } from '~/modules/common/components/ui';

export default defineComponent({
  components: {
    Arrow,
    OLink,
  },
  props: {
    stn: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const article = inject('article', null);
    const isOnedioVideo = computed(() => isVideoArticle(article) && !props.stn);
    return { article, isOnedioVideo };
  },
});
</script>
